import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { RecertFormData } from 'components/Assessments/RecertAssessment/types/RecertFormData'
import { RecertAssessmentQuestionnaireItem } from 'components/Assessments/RecertAssessment/types/questionnaire'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { RecertFormField } from 'components/Assessments/RecertAssessment/types/RecertFormField'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'

/**
 * History subsection adapter
 * Handles 60-day history tracking and medical/surgical history (14 fields)
 */
export class HistoryAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Other history fields
    const functionalLimitations = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS
    )

    const activitiesPermitted = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED
    )

    const medicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY
    )?.at(0)

    const surgicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY
    )?.at(0)

    return {
      [RecertFormField.HISTORY_FUNCTIONAL_LIMITATIONS]: functionalLimitations,
      [RecertFormField.HISTORY_ACTIVITIES_PERMITTED]: activitiesPermitted,
      [RecertFormField.HISTORY_MEDICAL_HISTORY]: medicalHistory,
      [RecertFormField.HISTORY_SURGICAL_HISTORY]: surgicalHistory
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RecertFormField.HISTORY_FUNCTIONAL_LIMITATIONS)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS,
        value: this.getFormDataField(RecertFormField.HISTORY_FUNCTIONAL_LIMITATIONS)
      })
    }

    if (this.formDataFieldExists(RecertFormField.HISTORY_ACTIVITIES_PERMITTED)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED,
        value: this.getFormDataField(RecertFormField.HISTORY_ACTIVITIES_PERMITTED)
      })
    }

    if (this.formDataFieldExists(RecertFormField.HISTORY_MEDICAL_HISTORY)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY,
        value: this.getFormDataField(RecertFormField.HISTORY_MEDICAL_HISTORY)
      })
    }

    if (this.formDataFieldExists(RecertFormField.HISTORY_SURGICAL_HISTORY)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY,
        value: this.getFormDataField(RecertFormField.HISTORY_SURGICAL_HISTORY)
      })
    }

    return mutations
  }
}
